import React from 'react';

// @mui
import { TableCell } from '@mui/material';
import { fDateTime } from '../../utils/formatTime';

export default class GridDateCell extends React.Component {
    render() {
        const baseStyle = this.props.styles;
        const { value, field } = this.props;
        const enableTime = field?.enableTime || false;
        return (
            <TableCell key={field.id} align="left" sx={{ ...baseStyle }}>
                {enableTime ? (fDateTime(value, 'd MMM yyyy HH:mm')) : (fDateTime(value, 'd MMM yyyy'))}
            </TableCell>
        );
    }
}
